import React from 'react';
import { SxProps, Theme } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { dateToYmdInEastern, ymdToLocalDate } from '../utils/easternTime';
import { fieldOnPageBlueSx } from '../mui/fieldOnPageBlue';

export interface AppDateFieldProps {
  label: string;
  value: string | null;
  onChange: (value: string | null) => void;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  required?: boolean;
  disabled?: boolean;
  helperText?: string;
  error?: boolean;
  usePageBlueStyle?: boolean;
  minDate?: Date | null;
  maxDate?: Date | null;
  sx?: SxProps<Theme>;
}

const AppDateField: React.FC<AppDateFieldProps> = ({
  label,
  value,
  onChange,
  fullWidth = true,
  size = 'small',
  required,
  disabled,
  helperText,
  error,
  usePageBlueStyle = false,
  minDate,
  maxDate,
  sx,
}) => {
  const textFieldSx = usePageBlueStyle ? { ...fieldOnPageBlueSx, ...sx } : sx;

  return (
    <DatePicker
      label={label}
      value={ymdToLocalDate(value)}
      onChange={date => onChange(date ? dateToYmdInEastern(date) : null)}
      disabled={disabled}
      minDate={minDate ?? undefined}
      maxDate={maxDate ?? undefined}
      showDaysOutsideCurrentMonth
      slotProps={{
        textField: {
          fullWidth,
          size,
          required,
          error,
          helperText,
          InputLabelProps: { shrink: true },
          sx: textFieldSx,
        },
      }}
    />
  );
};

export default AppDateField;
